import { StyleSheet, Dimensions } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const width = Dimensions.get('window').width;

export default StyleSheet.create({
  paymentMethodCardContainer: {
    flexDirection: 'column',
    marginVertical: 10,
  },
  cardName: theme => ({
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColorTwo,
    fontSize: 18,
    marginBottom: 15,
  }),
  cardContainer: {
    shadowOffset: { width: 2, height: 1 },
    shadowOpacity: 0.4,
    borderRadius: 10,
    elevation: 3,
  },
  innerContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: 10,
    flex: 1,
  },
  cardBackgroundContainer: {
    flex: 1,

    paddingHorizontal: 13,
  },
  cardBackgroundContainerImageStyle: {
    borderRadius: 10,
  },
  cardNumber: {
    color: Colors.white,
    fontSize: width / 12,
  },
  expiryDate: {
    flexDirection: 'row',
    marginTop: 5,
  },
  expiryDateKey: {
    width: 25,
    color: Colors.white,
    fontSize: 7.5,
    textTransform: 'uppercase',
  },
  expiryDateValue: {
    color: Colors.white,
    fontSize: 15,
    textTransform: 'uppercase',
  },
  nameOnCardWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  nameOnCard: {
    color: Colors.white,
    fontSize: 16,
    flex: 1,
    textTransform: 'uppercase',
  },
  divider: {
    width: '100%',
    height: 1,
    marginTop: 14,
  },
  makePreferred: {
    alignItems: 'flex-end',
  },
  makePreferredBtn: {
    width: 163,
    height: 39,
    marginTop: 20,
  },
  makePreferredBtnText: {
    fontSize: 18,
    letterSpacing: 0.09,
  },
  visaIcon: {
    width: 95,
    height: 45,
    bottom: 10,
  },
  cardChip: {
    width: 70,
    height: 60,
    right: 10,
  },
  visaPay: {
    width: 74,
    height: 31,
  },
});
